import { FC, lazy } from 'react'
import { Navigate, RouteObject } from 'react-router-dom'
import { Home } from '../features/home-page'
import { Segment } from '../features/segment'

const Dashboard = lazy(() => import('../__legacy__/components/platform/dashboard/Dashboard'))

const HomePage: FC = () => (
  <Segment.ViewTracker attributes={{ path: '/home' }}>
    <Home />
  </Segment.ViewTracker>
)

export const HomeRoute: RouteObject = {
  path: '/home',
  children: [
    {
      index: true,
      element: <Navigate to={'/home/songs'} replace />
    },
    {
      path: ':tab',
      element: <HomePage />
    }
  ]
}
